import React from 'react';
import {
  Input, Card, Table, Button, Breadcrumb,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import MainLayout from '@common/layouts/MainLayout';

import useBusinessType from './useBusinessType';
import styles from './BusinessType.module.less';

function BusinessType() {

  const { t } = useTranslation();
  const {
    loading,
    pagination,
    columns,
    businessType,
    arrayFilter,
    setValueFilter, 
    handleTableChange,
    createBusinessType,
    isCreate,
  } = useBusinessType();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.business_type')}</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.rowHeader}>
          <Input
            placeholder={t('common.business_type_find')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)} 
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />

          {
            isCreate && 
              <div className={styles.button}>
                {`• ${businessType.length} ${t('views.create_business_type.connectedBusinessType')}`}
                <Button type="primary" onClick={createBusinessType} icon={<PlusOutlined />}>
                  {t('views.create_business_type.new_business_type')}
                </Button>
              </div>
          } 
        </div>

        <Card>
          <Table
            // scroll={{ x: 1210 }}
            className={styles.table}
            loading={loading}
            columns={columns}
            dataSource={arrayFilter}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey={(record) => record.id}
          />
         </Card>
      </div>
    </MainLayout>
  );

}

export default withAuth(BusinessType);
